import { responsiveVariables } from "../../../utilities/props.js";
import "./position.css";
const position = (value) => {
    if (!value)
        return {};
    const variables = responsiveVariables("--rs-position", value);
    return { variables };
};
export default position;
